export default "__VITE_ASSET__931b3fcd__"